export default __webpack_public_path__ + "static/media/Horne FL 6.941fd38e.JPEG";